<section class="min-price-alert">
    <div class="alert alert-rounded alert-danger align-items-center" role="alert">
        <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
            <symbol id="exclamation-triangle-fill" fill="currentColor" viewBox="0 0 16 16">
                <path
                    d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
            </symbol>
        </svg>
        <div class="min-price-not-reaced-alert">
            <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Danger:">
                <use xlink:href="#exclamation-triangle-fill" />
            </svg>
            {{ 'checkout.min_price_not_reaced' | T}} {{ min_price | currency }} {{'checkout.min_price_not_reaced2' | T}}
        </div>
    </div>
    <div class="min-price-not-reached-legal">
        <h6 class="min-price">
            {{ 'checkout.min_price_not_reaced3' | T}}
            <a [routerLink]="['/subscribe']" class="text-uppercase font-weight-bold">
                {{ 'checkout.min_price_not_reaced3_bis' | T}}
            </a>
            {{ 'checkout.min_price_not_reaced3_ter' | T}}
        </h6>
        <h6 class="min-price">
            {{ 'checkout.min_price_not_reaced4' | T}}
        </h6>
    </div>
</section>